const getters = {};

export default getters;



// WEBPACK FOOTER //
// ./src/store/modules/clients/getters.js